import { Icon } from "components"
import { ControlButtonWrapper } from "modules/Call/components/ControlButtonWrapper"
import { PopperTooltip } from "modules/Call/components/HelpMoreMenuWrapper/PopperTooltip"
import style from "modules/Call/components/HelpMoreMenuWrapper/MoreButtonMenu/style.module.scss"

interface Props {
    onClick?: () => void
    isPsychotherapyMode?: boolean
    setIsPsychotherapyMode?: () => void
    onClickMoreButton?: (isOpen: boolean, tooltipRef: HTMLDivElement | null) => void
}

export function MoreButtonMenu({
    onClick,
    onClickMoreButton,
    isPsychotherapyMode,
    setIsPsychotherapyMode,
}: Props) {
    return (
        <PopperTooltip
            items={[
                {
                    id: 1,
                    icon: !isPsychotherapyMode ? "video-hide" : "video-show",
                    label: !isPsychotherapyMode
                        ? "Включить режим психотерапии"
                        : "Отключить режим психотерапии",
                    description: !isPsychotherapyMode
                        ? "cкрыть свое избражение, собеседник продолжит вас видеть"
                        : "",
                    action: () => (setIsPsychotherapyMode ? setIsPsychotherapyMode() : undefined),
                },
                {
                    id: 2,
                    icon: "help-circle-white",
                    label: "У меня проблемы со связью",
                    action: () => (onClick ? onClick() : undefined),
                },
            ]}
            openTooltip={onClickMoreButton}
        >
            <ControlButtonWrapper isRounded>
                <button className={style.videoControls__icon} type="button">
                    <Icon type="more-horizontal" size={28} />
                </button>
            </ControlButtonWrapper>
        </PopperTooltip>
    )
}
